import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import Vue from 'vue'
import VueApp from './VueApp.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import DrVueEcharts from 'dr-vue-echarts'
import * as Notificaciones from "@/notificaciones.js"

Vue.config.productionTip = false

Vue.directive('inputfilter-identificadorsensor', {
  inserted: function(el, _, vnode) {
    el.addEventListener('input', async function(e) {
      let start = e.target.selectionStart;
      let valor = e.target.value.replace(/[^0-9A-Fa-f]/g, '').toUpperCase();
      if (valor.length == e.target.value.length-1)  {
        start--;
      } else if (valor.length > 14) {
        start--;
        valor = valor.slice (0,start) + valor.slice(start+1);
      }
      await vnode.componentInstance.$emit('input', valor);
      e.target.setSelectionRange(start, start);
    })
  }
})

const global = new Vue({
  data: {
    cargando: false,
    deviceInfo: null,
    appActiva: true,
    numeroAlertasPendientes: 0,
    numeroAlertasPendientesDesde: null
  }
})
Vue.prototype.$global = global

import { Plugins } from '@capacitor/core';
const { Device } = Plugins;
const { App } = Plugins;

App.addListener('appStateChange', (state) => {
  global.appActiva = state.isActive;
});

Device.getInfo().then (value => {

  global.deviceInfo = value;

  store.dispatch ('ESTABLECER_ESTADO_INICIAL')

  Notificaciones.configurar();

  new Vue({
    router,
    store,
    vuetify,
    DrVueEcharts,
    render: h => h(VueApp)
  }).$mount('#app')
})
